import {
    FETCH_MODIFIER_LOOKUP_REQUEST,
    FETCH_MODIFIER_LOOKUP_SUCCESS,
    FETCH_MODIFIER_LOOKUP_FAILURE,
  } from "./FetchModifiersLookupTypes";
  import api from "../../utils/Api";
  
  export const fetchModifierLookupRequest = () => {
    return {
      type: FETCH_MODIFIER_LOOKUP_REQUEST,
    };
  };
  
  export const fetchModifierLookupSuccess = (modifierLookup) => {
    return {
      type: FETCH_MODIFIER_LOOKUP_SUCCESS,
      payload: modifierLookup,
    };
  };
  
  export const fetchModifierLookupFailure = (error) => {
    return {
      type: FETCH_MODIFIER_LOOKUP_FAILURE,
      payload: error,
    };
  };
  
  export const fetchModifierLookup = (payload) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/tariffcode/modifier/lookup/fetch?practitioner_id="+payload.practitioner_id+"&patient_id="+payload.patient_id +"&tariff_code="+payload.tariff_code

    return async (dispatch) => {
      dispatch(fetchModifierLookupRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
          }
        );
  
        const modifierLookup = response.data.data;
        dispatch(fetchModifierLookupSuccess(modifierLookup));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg =  error.response.data && 
        error.response.data.message?error.response.data.message: error.message;
        dispatch(fetchModifierLookupFailure(errorMsg));
      }
    };
  };
  